import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { useTranslation } from 'react-i18next';

export interface TransactionStateFilterStateControllerProps {
  value: TransactionModel['state'];
  onRemove: FilteredItemProps['onRemove'];
}

export const TransactionStateFilterStateController = ({
  value,
  onRemove,
}: TransactionStateFilterStateControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <FilteredItem
      icon="electric-car-2"
      label={t(`delmonicos-shared-sdk.enums-transaction-state.${value}`)}
      onRemove={onRemove}
    />
  );
};
